import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import api from '../services/api'; // 🔥 Import du client API

const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const location = useLocation();
    
    useEffect(() => {
        console.log('🔒 === PROTECTED ROUTE - CHECK ===');
        console.log('📍 Path demandé:', location.pathname);
        checkAuth();
    }, [location.pathname]);
    
    const checkAuth = async () => {
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');
        
        console.log('🔑 Token présent?', !!token);
        console.log('👤 User présent?', !!userStr);
        
        if (!token || !userStr) {
            console.log('❌ Pas de token/user, redirection vers /login');
            setIsAuthenticated(false);
            return;
        }
        
        try {
            console.log('🔍 Vérification token avec backend via API client...');
            
            // 🔥 UTILISE LE CLIENT API AU LIEU DE FETCH
            const response = await api.get('/auth/profile');
            
            const data = response.data;
            
            if (data.success && data.user) {
                console.log('✅ Token valide, utilisateur:', data.user.email);
                setIsAuthenticated(true);
                
                // Mettre à jour les données utilisateur en localStorage
                localStorage.setItem('user', JSON.stringify(data.user));
            } else {
                console.log('❌ Token invalide:', data.message);
                setIsAuthenticated(false);
                localStorage.removeItem('token');
                localStorage.removeItem('user');
            }
        } catch (error) {
            console.error('❌ Erreur vérification auth:', error);
            
            // 🔥 Gestion erreur Axios
            if (error.response) {
                console.error('Status:', error.response.status);
                console.error('Data:', error.response.data);
            }
            
            setIsAuthenticated(false);
            localStorage.removeItem('token');
            localStorage.removeItem('user');
        }
    };
    
    // État de chargement
    if (isAuthenticated === null) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column',
                fontFamily: 'Arial, sans-serif'
            }}>
                <div style={{
                    width: '50px',
                    height: '50px',
                    border: '5px solid #f3f3f3',
                    borderTop: '5px solid #e74c3c',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>
                <p style={{ marginTop: '20px', color: '#666' }}>
                    🔍 Vérification de l'authentification...
                </p>
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}
                </style>
            </div>
        );
    }
    
    // Rediriger vers login si pas authentifié
    if (!isAuthenticated) {
        console.log('❌ ProtectedRoute: Redirection vers /login');
        return <Navigate to="/login" replace />;
    }
    
    console.log('✅ ProtectedRoute: Accès autorisé');
    return children;
};

export default ProtectedRoute;